<template>
  <section>
    <slot />
    <CEmptyState
      v-if="showLimitMessage"
      class="drawer-tab__state"
      no-border
      icon="conversation"
      :message="`Ufa, carregamos ${currentResultsLimit} canais.<br>Se quiser encontrar um membro específico, use a busca.`"
    >
      <template #image>
        <WIcon icon="icChat" size="large" />
      </template>
    </CEmptyState>
    <CEmptyState
      v-else-if="showLastPage"
      class="drawer-tab__state"
      no-border
      icon="conversation"
      message="Ufa, você chegou no final!"
    >
      <template #image>
        <WIcon icon="icChat" size="large" />
      </template>
    </CEmptyState>

    <HCardPlaceholder v-else-if="onMountPlaceholder" :count="5" />
    <HCardPlaceholder
      v-else-if="showPlaceholder"
      v-observe-visibility="observeVisibility"
      :count="1"
    />
  </section>
</template>

<script>
import { WIcon } from '@alice-health/wonderland-vue'
import debounce from 'lodash/debounce'
import { mapState } from 'vuex'

import { HCardPlaceholder } from '@/components/shared/atoms'

import { CEmptyState } from '../../atoms'

export default {
  components: { WIcon, CEmptyState, HCardPlaceholder },
  props: {
    resultsCount: { type: [Number, undefined], default: undefined },
    tabCounters: {
      type: Object,
      default() {
        return {}
      }
    },
    hidePlaceholder: Boolean
  },
  emits: ['load'],
  data() {
    return {
      showLastPage: false
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('channel/drawer', ['currentFilters', 'currentPage']),
    showPlaceholder() {
      return this.resultsCount !== 0 && !this.hidePlaceholder
    },
    onMountPlaceholder() {
      return this.resultsCount === undefined
    },
    currentResultsLimit() {
      return Math.max(
        100,
        this.tabCounters.privateUnreadMessages,
        this.tabCounters.unreadMessages
      )
    },
    showLimitMessage() {
      if (this.currentFilters.channelPersonId) return false
      return this.resultsCount > this.currentResultsLimit
    },
    observeVisibility() {
      if (!this.user?.id) return false
      return {
        callback: this.load,
        throttle: 300
      }
    }
  },
  watch: {
    resultsCount: 'handleLastPage'
  },
  mounted() {
    this.load(true)
  },
  methods: {
    load(isVisible) {
      if (isVisible) {
        this.$store.commit('channel/drawer/increaseCurrentPage')
        this.$emit('load')
        this.handleLastPage()
      }
    },
    handleLastPage: debounce(function () {
      this.showLastPage =
        this.resultsCount > 0 && this.resultsCount < this.currentPage * 10
    }, 500)
  }
}
</script>

<style>
section.drawer-tab__state[style] {
  padding: 0;
  gap: var(--gl-spacing-03);
}
</style>
